import { render, staticRenderFns } from "./notice_log.vue?vue&type=template&id=78193c0c&scoped=true&"
import script from "./notice_log.vue?vue&type=script&lang=js&"
export * from "./notice_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78193c0c",
  null
  
)

export default component.exports